// @flow
import React, {Component} from "react";
import PhonePopup from "../PhonePopup";
import Header from "../Header";
import Baner from "../Baner";
import Hydroisolation from "../Hydroisolation";
import AgainstWater from "../AgainstWater";
import WaterHard from "../WaterHard";
import Footer from "../Footer";
import AbizolTable from "../AbizolTable";
import EvomerTable from "../EvomerTable";
import WallSection from "../WallSection";
import WallSection2 from "../WallSection";
import SamplePopup from "../SamplePopup";
import RoofHeader from "../RoofHeader";
import RoofStep1 from "../RoofStep1";
import LazyLoad from "react-lazyload";
import s from "./Foundation.scss";

export default class Foundation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: "",
      popupForm: false,
      samplePopupForm: false,
    };

    this.popup = false;
  }
  scrollWithOffset = (el, offset) => {
    const elementPosition = el.offsetTop - offset;
    if (typeof window !== "undefined") {
      window.scroll({
        top: elementPosition,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  // componentDidMount = () => {
  //   this.popup = setTimeout(this.openSamplePopupForm, 2000);
  // };

  componentWillUnmount = () => {
    clearTimeout(this.popup);
  };

  openPopupForm = () => {
    this.setState({popupForm: true});
  };

  closePopupForm = () => {
    this.setState({popupForm: false});
  };

  // openSamplePopupForm = () => {
  //   this.setState({samplePopupForm: true});
  // };

  // closeSamplePopupForm = () => {
  //   this.setState({samplePopupForm: false});
  // };

  render() {
    const ssr =
      typeof this.props.ssr !== undefined && this.props.ssr ? true : false;
    return (
      <div className="roof-body">
        {/* {this.state.samplePopupForm ? (
          <SamplePopup closePopupForm={this.closeSamplePopupForm} />
        ) : null} */}

        {/* <button
          onClick={this.openSamplePopupForm}
          className="home__popup-button sample"
        >
          Odbierz darmową próbkę
        </button> */}

        {this.state.popupForm ? null : (
          <button onClick={this.openPopupForm} className="home__popup-button">
            Masz pytania?
          </button>
        )}

        <div id="foundations" className="white-bg">
          <Header type="foundation-header" />
          <PhonePopup
            popupForm={this.state.popupForm}
            closePopupForm={this.closePopupForm}
          />
          <Baner />
          <Hydroisolation />
          <WallSection />
          <EvomerTable />
          <AgainstWater />
          <WaterHard />
          <WallSection />
          <AbizolTable />
          <Footer />
          <div id="bottom-found"></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Foundation/Foundation.js